
<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Modelo:"
    id="selectModelo"
    placeholder="Selecione a Modelo"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import TemplateRepository from '@/shared/http/repositories/configurations/templates.js'

export default {
  name: 'NxSelectCampanhaModelo',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadModelos()
  },
  methods: {
    onLoadModelos () {
      TemplateRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Modelos', 'Erro')
          console.error(err)
        })
    },
    // onGetAllSegmentation () {
    //   loading.push()
    //   SegmentationRepository.GetAllSortedByNome()
    //     .then((response) => {
    //       this.form.listaId.listOptions = this.onResultDropdown(response, null, f => f.nome)
    //     })
    //     .catch(this.onException)
    // },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectCampanhaModelo.vue